var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page"},[(_vm.userPrivilegeMapping[70])?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadings.main),expression:"loadings.main"}],staticClass:"row row-eq-height"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }